export const CodingConstants = {
    WelcomeNoteId: 'welcome_note',
    customerPortal: 'authenticated_customer_portal',
    customerPortal2: 'authenticated_customer_portal2',
    servicingLoan: 'ServicingLoanNumber',
    mobileWidget: 'mobile_widget',
    dashboard: 'dashboard',
    newLoanInProgress: 'newLoanInProgress',
    servicingLoanType: 'ServicingLoanNumber',
    inProgressLoanType: 'OriginationLoanNumber',
    purchaseWidgetId: 'purchase_widget',
    marketingId: 'marketing',
    paynowId: 'pay_now',
    loanInProgressId: 'status_tracker_widget',
    servicingLoanDetailsId: 'account_summary',
    servicingType: 'servicing',
    myprofileId: 'my_profile',
    currentAccount: 'Current Account',
    paymentDueNow: 'Payment Due Now',
    pastDue: 'Past Due',
    delinquent: 'Delinquent',
    escrow: 'escrow',
    authCashOut: 'authCashOut',
    accountConnect: 'account_connect',
    siteAdmin: 'site_admin_url',
    myFreedomPortal: 'My_Freedom_Portal',
    cashOutOfferId: 'cashout_widget',
    monthlyStmt: 'monthly_statement',
    taxDoc: 'tax_doc',
    escrowDoc: 'escrow_doc',
    servicingError: 'account/FETCH_ACCOUNT_FAILURE',
    widgetsError: 'widgets/FETCH_WIDGETS_FAILURE',
    paperlessError: 'enroll/FETCH_PAPERLESS_FAILURE',
    paperLess: 'paperless_widget',
    eligibleForEscrowComplete: 'escrow-analysis-complete',
    eligibleForEscrowScheduled: 'escrow-analysis-scheduled',
    accountSummaryWidget: 'account_summary_widget',
    loanInProgressWidgetId: 'loan_in_progress_widget',
    taxDocumentWidget: 'TaxDocumentWidget',
    DXOCContent: 'DXOCContent',
    authRefi: 'authRefi',
    naturalDisaster: 'natural_disaster_widget',
    naturalDisasterAssistance: 'natural_disaster_assistance',
    offerGroup: 'Bundle_offers',
    teaserOfferGroup: 'Bundle_offers_teaser_offer',
    authRefiSL: 'authRefiSL',
    authRefiRT: 'authRefiRT',
    inProgressLoanTypeV2: 'OriginationLoanNumber',
    turboTaxPopUp: 'TurboTaxPopup',
    onboardingWidget: 'customer_onboarding',
    nextBasedPopupWidgetId: 'next-best-popup',
    homeValueWidgetId: 'HV',
    pendingServiceReleased: 'Pending Service Release',
    severelyDelinquent: 'Severely Delinquent',
    severelyDelinquentWithRP: 'Severely Delinquent with RP',
    delinquentWithRP: 'Delinquent with RP',
    showDashStatusList: [
        'PaidOffStatus',
        'InactiveStatus',
        'statusServiceReleased',
        'statusForeclosed',
        'activeForeclosure',
        'statusBankruptcy',
        'ActiveLossMitigationForeclosureHold'
    ],
    showPlannedDueStatusList: ['statusDelinquentRP', 'statusSevereDelRP', 'statusLossMitigationRepaymentPlan'],
    disablepaynowStatusKeyList: [
        'ActiveLossMitigationForeclosureHold',
        'statusBankruptcy',
        'statusForeclosed',
        'activeForeclosure',
        'PaidOffStatus',
        'statusServiceReleased',
        'InactiveStatus'
    ],
    enableautoPayStatusList: ['Current Account', 'Payment Due Now', 'Past Due'],
    disableStatementStatusList: ['Foreclosed'],
    deepLinkPopupFilters: ['OB-WELCOME', 'OB-TCPA', 'OB-PAPERLESS', 'OB-MOBILEAPP', 'DISASTER']
};

export const cmsNameToID: any = {
    quickActions: '0f5a0ee6-5ebf-4265-9724-860928a05958',
    featureProducts: 'd0173c13-2d8d-4246-8447-3fe6de1f8e50',
    paperless: '959da172-b9fc-441b-9261-92075fb13fa1'
};

export const NotificationDefaultValue = {
    imgSrc: 'https://dam.freedommortgage.com/dx/api/dam/v1/collections/7b101923-c80f-4471-a651-acf2e18ecdaa/items/6f15ac3b-9c3d-49a3-b7c9-07b2c2542894/renditions/2e004944-3ec6-4ed8-8d3f-e521def4edc1?binary=true',
    borderColor: '#173147'
};

export const NotificationData: any = {
    emergency: {
        imgSrc: 'https://dam.freedommortgage.com/dx/api/dam/v1/collections/563a2e94-abdb-4eda-a407-49cc1380b6f4/items/c3ea7564-a64e-4e97-8991-5b475943329d/renditions/a5603f8d-da74-4288-9ead-72cc5940e060?binary=true',
        borderColor: 'red'
    },
    warning: {
        imgSrc: 'https://dam.freedommortgage.com/dx/api/dam/v1/collections/7b101923-c80f-4471-a651-acf2e18ecdaa/items/03f3d117-02cb-48ef-802c-3936891fb854/renditions/25e2dbe9-e5a4-43eb-a5a6-2e02f7ede07d?binary=true',
        borderColor: '#D68612'
    },
    schedule: NotificationDefaultValue
};
export const WelcomeBarData: any = {
    escrow: [
        {
            pageName: 'escrow',
            title: 'Escrow Analysis',
            description: 'Escrow Analysis',
            loanType: 'escrow',
            isClickable: false,
            isActive: true,
            isLoanDropDownNeeded: false
        }
    ],
    inProgressLoanType: [
        {
            pageName: 'OriginationLoanNumber',
            title: 'Loan Progress',
            description: 'Your New Loan Progress',
            loanType: 'OriginationLoanNumber',
            isClickable: false,
            isActive: true,
            isLoanDropDownNeeded: true
        }
    ],
    cashOut: [
        {
            pageName: 'authCashOut',
            title: 'Cash Out Form',
            description: 'Refinance and Get Cash From Your Home Equity',
            loanType: 'authCashOut',
            isClickable: false,
            isActive: true,
            isLoanDropDownNeeded: false
        }
    ],
    authRefi: [
        {
            pageName: 'authRefi',
            title: 'Refinance Your Mortgage',
            description: 'Refinance your existing Mortgage',
            loanType: 'authRefi',
            isClickable: false,
            isActive: true,
            isLoanDropDownNeeded: false
        }
    ],
    authRefiFullApp: [
        {
            pageName: 'authRefi',
            title: 'My Application',
            description: 'My Application',
            loanType: 'authRefi',
            isClickable: false,
            isActive: true,
            isLoanDropDownNeeded: false
        }
    ],
    naturalDisaster: [
        {
            pageName: 'naturalDisaster',
            title: 'Natural Disaster Declaration',
            description: 'Natural Disaster Declaration',
            loanType: 'naturalDisaster',
            isClickable: false,
            isActive: true,
            isLoanDropDownNeeded: true
        }
    ],
    naturalDisasterAssistance: [
        {
            pageName: 'naturalDisaster',
            title: 'Natural Disaster Assistance',
            description: 'Natural Disaster Assistance',
            loanType: 'naturalDisasterAssistance',
            isClickable: false,
            isActive: true,
            isLoanDropDownNeeded: true
        }
    ],
    authPurchase: [
        {
            pageName: 'authPurchase',
            title: 'Purchase a new home',
            description: 'Purchase a new home',
            loanType: 'authPurchase',
            isClickable: false,
            isActive: true,
            isLoanDropDownNeeded: false
        }
    ],
    inProgressLoanTypeV2: [
        {
            pageName: 'OriginationLoanNumber',
            title: 'Loan Progress',
            description: 'Your New Loan in Progress',
            loanType: 'OriginationLoanNumber',
            isClickable: false,
            isActive: true,
            isLoanDropDownNeeded: true
        }
    ]
};
export const PromotionWidgetData = ['escrow', 'ServicingLoanNumber'];

export const FooterComponentData = {
    nmlsConsumerLink: {
        link: 'https://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/2767',
        text: 'NMLS Consumer Access.'
    },
    footerLinks: [
        { link: 'https://www.freedommortgage.com/disclosures', text: 'Legal Disclosures' },
        { link: 'https://www.freedommortgage.com/disclosures/privacy-policy', text: 'Privacy Notice' },
        { link: 'https://www.freedommortgage.com/disclosures/california-privacy-policy', text: 'California Privacy Notice' },
        { link: 'https://www.freedommortgage.com/disclosures/terms-and-conditions', text: 'Terms and Conditions' },
        { link: 'https://www.freedommortgage.com/disclosures/state-licensing', text: 'State Licensing' }
    ],
    copyRight: '© Freedom Mortgage Corporation.'
};
export const NBPPopupTemplateTypes = ['OFFERPOP3', 'OFFERPOP1', 'OFFERPOP2'];
